export default "/images/audit_badge/audit_badge__icon.png";